import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../../../core/services/keycloakApi";
import {
  REALM,
  CLIENT_NAME,
} from "../../../core/constants/keycloakCredentials";
import { getUserErrorMessage, logApiError } from "../../../core/utils/apiErrorUtils";

const isValidPassword = (password) => password && password.length >= 4;

export const useResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const tempErrors = {};
    let valid = true;

    if (!isValidPassword(newPassword)) {
      tempErrors.newPassword = "Password must be at least 4 characters";
      valid = false;
    }

    if (newPassword !== confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
      valid = false;
    }

    setErrors(tempErrors);
    return valid;
  };

  const handleNewPasswordChange = (value) => {
    setNewPassword(value);
    if (errors.newPassword) {
      setErrors((prev) => ({ ...prev, newPassword: "" }));
    }
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
    if (errors.confirmPassword) {
      setErrors((prev) => ({ ...prev, confirmPassword: "" }));
    }
  };

  const buildPayload = () => ({
    realm: REALM,
    clientName: CLIENT_NAME,
    newPassword,
    confirmPassword,
    resetToken,
  });

  const handleSubmit = async (event) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }

    if (!validate()) return;

    if (!resetToken) {
      setError("Invalid or expired reset link");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await resetPassword(buildPayload());
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      logApiError("Reset password", err);
      setError(getUserErrorMessage(err, "Reset link expired or invalid."));
    } finally {
      setLoading(false);
    }
  };

  return {
    newPassword,
    confirmPassword,
    loading,
    error,
    success,
    errors,
    handleNewPasswordChange,
    handleConfirmPasswordChange,
    handleSubmit,
  };
};
